export default "__VITE_ASSET__BajsmLmZ__"